export default "__VITE_PUBLIC_ASSET__b52c6835__"